import type { AttrKind } from '../types/attr-kind'

/** `type:"decimal" precision:"6"` - up to six decimals, trailing zeros trimmed. */
export function formatDecimal(raw: unknown): string {
  const n = Number(raw)

  if (!Number.isFinite(n)) return '0'

  const trimmed = n.toFixed(6).replace(/\.?0+$/, '')

  return trimmed === '' || trimmed === '-' ? '0' : trimmed
}

export function formatUint(raw: unknown): string {
  const n = Number(raw)

  return Number.isFinite(n) ? String(Math.trunc(n)) : '0'
}

export function toBool(raw: unknown): boolean {
  return raw === true || raw === 'true' || raw === 1 || raw === '1'
}

export function formatValue(raw: unknown, kind: AttrKind): string {
  switch (kind) {
    case 'decimal':
      return formatDecimal(raw)
    case 'uint':
      return formatUint(raw)
    case 'boolTrueFalse':
      return toBool(raw) ? 'true' : 'false'
    case 'bool01':
      return toBool(raw) ? '1' : '0'
    case 'string':
      return String(raw)
  }
}
